<script setup>
setPageTitle(PageMeta.Products.Preview.Title)
definePage({ meta: PageMeta.Products.Preview.Meta })

import ProductPreviewPage from '@/views/apps/products/preview/ProductPreviewPage.vue'

const route = useRoute()

/* ** */
</script>

<template>
  <section>
    <!-- Horizontal Menu / Navigation -->
    <VRow>
      <VCol cols="12">
        <HorizontalProductsMenu />
      </VCol>
    </VRow>

    <!-- Page -->
    <VRow>
      <VCol cols="12">
        <ProductPreviewPage :product-g-u-i-d="route.params.guid" />
      </VCol>
    </VRow>
  </section>
</template>
